import React, { useState } from "react";
import { Upload, X, Image as ImageIcon, Check } from "lucide-react";

interface PhotoUploadProps {
    onUpload?: (files: File[]) => void;
}

const PhotoUpload: React.FC<PhotoUploadProps> = ({ onUpload }) => {
    const [selectedImages, setSelectedImages] = useState<{ file: File; preview: string }[]>([]);

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            const newFiles = Array.from(e.target.files);
            const newImages = newFiles.map(file => ({
                file,
                preview: URL.createObjectURL(file)
            }));
            setSelectedImages(prev => [...prev, ...newImages]);
            if (onUpload) onUpload([...selectedImages.map(i => i.file), ...newFiles]);
        }
    };

    const removeImage = (index: number) => {
        const updatedImages = [...selectedImages];
        URL.revokeObjectURL(updatedImages[index].preview);
        updatedImages.splice(index, 1);
        setSelectedImages(updatedImages);
    };

    return (
        <div className="photo-upload-container" style={{ padding: "32px", height: "100%", overflowY: "auto" }}>
            <div
                className="upload-dropzone"
                style={{
                    border: "2px dashed #cbd5e1",
                    borderRadius: "16px",
                    padding: "48px",
                    textAlign: "center",
                    background: "#f8fafc",
                    cursor: "pointer",
                    transition: "border-color 0.2s"
                }}
                onClick={() => document.getElementById("file-upload")?.click()}
            >
                <div style={{ background: "white", width: "64px", height: "64px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)" }}>
                    <Upload style={{ margin: "auto", color: "#64748b" }} size={32} />
                </div>
                <h3 style={{ fontSize: "18px", fontWeight: "700", marginBottom: "8px", color: "#1e293b" }}>Click to upload photos</h3>
                <p style={{ color: "#64748b", fontSize: "14px" }}>Take a photo of your written work and upload it here.</p>
                <input
                    id="file-upload"
                    type="file"
                    multiple
                    accept="image/*"
                    onChange={handleImageChange}
                    style={{ display: "none" }}
                />
            </div>

            {selectedImages.length > 0 && (
                <div style={{ marginTop: "32px" }}>
                    <h4 style={{ fontSize: "14px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "1px", color: "#94a3b8", marginBottom: "16px" }}>
                        Uploaded Photos ({selectedImages.length})
                    </h4>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: "16px" }}>
                        {selectedImages.map((img, idx) => (
                            <div key={idx} style={{ position: "relative", borderRadius: "12px", overflow: "hidden", border: "1px solid #e2e8f0", aspectRatio: "1" }}>
                                <img
                                    src={img.preview}
                                    alt="preview"
                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                                <button
                                    onClick={(e) => { e.stopPropagation(); removeImage(idx); }}
                                    style={{ position: "absolute", top: "8px", right: "8px", background: "rgba(0,0,0,0.5)", color: "white", border: "none", borderRadius: "50%", width: "24px", height: "24px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
                                >
                                    <X size={14} />
                                </button>
                                <div style={{ position: "absolute", bottom: "0", left: "0", right: "0", background: "rgba(255,255,255,0.9)", padding: "4px 8px", fontSize: "10px", fontWeight: "600", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                    {img.file.name}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default PhotoUpload;
